// @ts-check

import { createI18n } from 'vue-i18n'
import { en, fi } from 'vuetify/locale'

export const locale = 'fi'

export const fallbackLocale = 'en'

/**
 * All available languages (these have their on folders)
 */
export const languages = ['en', 'fi']

const vuetifyLocales = {
  en,
  fi
}

/**
 * Load these file names from the language folders determined above. When adding
 * a new file, just add it's name to this array and it will be added to each
 * language's translations
 */
const files = [
  'translations', // This has to be first for some unknown reason.
  'account_transactions',
  'alert',
  'bank_account',
  'bank_transactions',
  'board_members',
  'company',
  'company_founding',
  'courier',
  'customers',
  'dashboard',
  'datatable',
  'dates',
  'debt_collection',
  'driving_log',
  'entries',
  'entry_edit',
  'entry',
  'errors',
  'features',
  'form',
  'general',
  'invoice_financing',
  'invoicing',
  'kyc',
  'links',
  'login',
  'mobile',
  'notifications',
  'onboarding',
  'outboarding',
  'password_confirmation',
  'payment_terminal',
  'product_register',
  'references',
  'registration_flow',
  'registration',
  'registries',
  'reporting_dimensions',
  'insights',
  'reports',
  'routes',
  'salary',
  'settings',
  'shareholders',
  'single_entry',
  'stripe',
  'subscriptions',
  'spotlight',
  'business_account',
  'tax_return',
  'tax_return_questionnaire',
  'subscription_dialogs',
  'subscription_plan',
  'terms_of_service',
  'ukko_assurance',
  'validation',
  'vehicle_details',
  'verifications',
  '$vuetify',
  'files',
  'yel',
  'ukko_plus'
]

/**
 * This translations object will be composed from languages and their matching
 * files by using dynamic requires.
 */
/** @type {Record<string, any>} */
const translations = languages.reduce((languageAcc, language) => {
  const languageKey = /** @type {keyof typeof vuetifyLocales} */ (language)

  const languageTranslations = files.reduce((fileAcc, name) => {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const file = require(`@/lang/${language}/${name}.json`)
    if (name === 'translations') {
      return { ...file }
    }

    if (name === '$vuetify') {
      const vuetifyLocale = vuetifyLocales[languageKey] ?? {}
      return { ...fileAcc, $vuetify: { ...vuetifyLocale, ...file } }
    }

    return {
      ...fileAcc,
      [name]: file
    }
  }, /** @type {Record<string, any>} */ ({}))

  return {
    ...languageAcc,
    [language]: languageTranslations
  }
}, /** @type {Record<string, any>} */ ({}))

export const messages = {
  en: { ...translations.en },
  fi: { ...translations.fi }
}

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale,
  messages,
  allowComposition: true
})

export default i18n
